module.exports = __webpack_public_path__ + "static/media/slider07.cc3aa485.jpg";